export enum BUSINESS_MODELS {
  DIRECT_SALE = 1,
  ADMINISTRATIVE = 2,
  COLLABORATOR = 3
}
